/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IRental, Rental } from "@/models/rental.entity";

/**
 * Data Access Layer for Rental
 */
export const RentalDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IRental> {
  /**
   * Returns a new entity based on the data provided.
   * @param el The data to create the entity from
   * @returns A new IRental object
   */
  protected mapEntity(el: Partial<IRental>): IRental {
    return new Rental(el);
  }

  /**
   * Returns the id of an entity.
   * @param el The entity to get the id from
   * @returns The id of the entity
   */
  getIdentifier(el: IRental): string {
    return el.id;
  }
})();
